import { useState } from "react";
import {
  DatePicker,
  Select,
  InputNumber,
  Button,
  Image,
  Form,
  Typography,
} from "antd";
import dayjs from "dayjs";
import "antd/dist/reset.css"; // reset antd styles
import visaSearchBg from "../assets/images/visaDetailsBg.jpg";
import PriceRangeDropdown from "./PriceRangeDropdown.jsx";
import RoomsGuestsDropdown from "./RoomsGuestsDropdown.jsx";
import CustomDateRange from "./CustomDateRange.jsx";
import sliderImg from "../assets/images/bannerHotel.jpg";
import TravelMonthSelector from "./TravelMonthSelector.jsx";
import TravelMonthDropdown from "./TravelMonthSelector.jsx";
import TravelPage from "./TravelDateDisplay.jsx";
import TravelDateDisplay from "./TravelDateDisplay.jsx";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text, Paragraph } = Typography;

export default function VisaDetailSearch() {
  const [formData, setFormData] = useState({
    country: "UAE",
    city: "Dubai",
    checkIn: dayjs("2025-08-10"),
    checkOut: dayjs("2025-08-11"),
    rooms: 1,
    guests: 2,
    price: [2500, 5000],
  });

  return (
    <div className="relative bg-cover bg-center flex items-center justify-center min-h-[500px]">
      <Image
        src={visaSearchBg}
        alt="Slide 1"
        className="w-full !h-full object-cover min-h-[500px]"
        preview={false}
        style={{ height: "100%" }}
      />

      <div className="container absolute z-10 bottom-8">
        <div className=" bg-white shadow-[0px_4px_6px_1px_rgba(0,0,0,0.25)] rounded-2xl">
          <Form
            layout="vertical"
            className="grid grid-cols-4 gap-4  rounded-md bg-white  px-4"
          >
            {/* Country */}
            <Form.Item
              name="country"
              label="Select Country"
              className="col-span-1 m-0 font-medium border-r py-4"
            >
              <Select
                defaultValue={formData.country}
                bordered={false}
                size="large"
                className="w-full custom-select text-primary"
              >
                <Option value="UAE">UAE</Option>
                <Option value="Thailand">Thailand</Option>
                <Option value="USA">USA</Option>
                <Option value="France">France</Option>
              </Select>
            </Form.Item>

            {/* City */}
            <Form.Item
              name="city"
              label="Select City"
              className="font-medium col-span-1 m-0 py-4 border-r"
            >
              <Select
                defaultValue={formData.city}
                bordered={false}
                size="large"
                className="w-full custom-select text-danger"
              >
                <Option value="Dubai">Dubai</Option>
                <Option value="Bangkok">Bangkok</Option>
                <Option value="New York">New York</Option>
                <Option value="Paris">Paris</Option>
              </Select>
            </Form.Item>

            {/* Rooms & Guests */}
            <Form.Item
              label=""
              className="col-span-1 m-0 font-medium py-4 border-r"
            >
              <TravelDateDisplay />
            </Form.Item>
            {/* Button */}
            <div className="text-center col-span-1 mt-8 mb-[-55px]">
              <Button
                type="danger"
                size="middle"
                className="rounded-full w-3/4 py-7 shadow-md text-xl font-medium flex-1 
             bg-danger hover:bg-red-700 border-none 
             text-white"
              >
                Search
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}
